import {
    ProQaEventMetadataRequest,
    ProQaEventMetadataResponse,
    ProQaResource,
} from '@mark43/cad-api';
import type { TypeBoundAxiosInstance } from '@m43/shared';

type ApiClientLike = Pick<TypeBoundAxiosInstance, 'request'>;

export const proQaResources = (apiClient: ApiClientLike) => {
    const processCommunication = async (xml: string) => {
        return apiClient.request<ProQaResource.ProcessProQaCommunication>({
            method: 'POST',
            url: 'pro_qa/process/',
            data: { xml },
        });
    };

    const getDraftEventMetadata = async (request: ProQaEventMetadataRequest) => {
        const response = await apiClient.request<ProQaResource.GetProQaEventMetadata>({
            method: 'POST',
            url: 'pro_qa/event/metadata/',
            data: request,
        });
        return response.data?.data as ProQaEventMetadataResponse | undefined;
    };

    const consumePendingSecondaryLaunches = async (agencyEventNumber: string) => {
        const response = await apiClient.request<ProQaResource.ConsumePendingSecondaryLaunches>({
            method: 'POST',
            url: 'pro_qa/secondary_launches/consume/',
            data: { agencyEventNumber },
        });
        return response.data?.data?.pendingSecondaryProQaLaunches;
    };

    return { processCommunication, getDraftEventMetadata, consumePendingSecondaryLaunches };
};

export type ProQaResourceClient = ReturnType<typeof proQaResources>;
